module.exports = {
    password: 'La contraseña debe tener seis caracteres como mínimo y debe coincidir con la confirmación.',
    reset: 'Tu contraseña ha sido reiniciada.',
    sent: 'Hemos enviado un vínculo a tu correo electrónico para reiniciar tu contraseña.',
    token: 'Este token de reinicio de contraseña es inválido.',
    user: 'No podemos encontrar a un usuario con esa dirección de correo electrónico.',
    password_too_short: 'La contraseña debe tener al menos seis caracteres.',
    password_mismatch: 'La contraseña debe coincidir con el campo de confirmación.'
}